import { StorageV2Translations } from "../../../pt-BR/place/storage/storage-v2";

const productsTable: StorageV2Translations["tabs"]["products"]["table"] = {
	columns: {
		product: "Producto",
		fiscalCode: "SKU",
		category: "Categoría",
		categoryFilterButton: "Filtrar por categoría {{categoryName}}",
		quantity: "Cantidad",
		lastUnitCost: "Último costo",
		avgUnitCost: "Costo medio",
		totalAvgCost: "Costo total",
		actions: {
			seeProductDetails: "Ver detalles del producto",
			transferProduct: "Transferir producto",
			removeProduct: "Eliminar producto",
			ariaLabels: {
				button: "Ações do produto {{productName}}",
				details: "Ver detalhes do produto {{productName}}",
				transfer: "Transferir produto para outro estoque",
				remove: "Remover produto do estoque",
			},
		},
	},
	quantityInput: {
		add: "Agregar cantidad de {{productName}}",
		remove: "Quitar cantidad de {{productName}}",
		cannotRemove: "No es posible quitar cantidad porque el producto está cero",
	},
};

const addStorageProductDrawer: StorageV2Translations["tabs"]["products"]["addStorageProductDrawer"] = {
	title: "Agregar producto",
	successMessage: "¡Producto añadido exitosamente!",
	errorMessage: "Error al agregar producto al inventario.",
	form: {
		product: "Producto",
		productPlaceholder: "Seleccione el producto",
		quantity: "Cantidad",
		unitCostValue: "Precio de costo",
		unitCostValueType: "Valor por",
		totalCostValue: "Precio total",
		costValueByUnit: "Precio por {{unit}}",
		validation: {
			productIsRequired: "Seleccione un producto",
			quantityMustBeGreaterThanZero: "La cantidad debe ser mayor que cero",
			invalidQuantity: "Cantidad inválida",
			maxValue: "El valor máximo es {{maxValue}}",
		},
		actions: {
			cancel: "Cancelar",
			add: "Agregar producto",
		},
	},
};

const importInvoiceDrawer: StorageV2Translations["tabs"]["products"]["importInvoiceDrawer"] = {
	title: "Importar factura",
	errorMessage: "Error al importar factura.",
	content: {
		title: "Importar XML de factura",
		subtitle: "Cargue el archivo XML de una factura de compra",
	},
	validation: {
		xmlRequired: "El archivo XML es obligatorio.",
	},
	upload: {
		dropzoneTitle: "Arrastra y suelta el archivo aquí",
		dropzoneSubtitle: "o haz clic para seleccionar el archivo",
		fileDetails: "Archivo XML",
		uploadErrorMessage: "No se pudo leer el archivo.",
		invalidFileTitle: "Archivo inválido",
		invalidFileReasonDefault: "El archivo seleccionado es inválido.",
		invalidFileReasonInvalidType: "Formato inválido. Formatos aceptados: {{formats}}",
	},
	actions: {
		cancel: "Cancelar",
		import: "Importar",
	},
};

const adjustStorageProductDrawer: StorageV2Translations["tabs"]["products"]["adjustStorageProductDrawer"] = {
	input: {
		title: "Agregar cantidad de {{productName}}",
	},
	remove: {
		title: "Quitar cantidad de {{productName}}",
	},
	form: {
		product: "Producto",
		addQuantity: "Cantidad que desea agregar",
		removeQuantity: "Cantidad que desea remover",
		unitCostValue: "Precio de costo",
		observations: "Observaciones",
		validation: {
			quantityMustBeGreaterThanZero: "La cantidad debe ser mayor que cero",
			invalidQuantity: "Cantidad inválida",
			maxValue: "La cantidad máxima es {{maxValue}}",
		},
		actions: {
			cancel: "Cancelar",
			add: "Agregar cantidad",
			remove: "Remover cantidad",
		},
		productionRuleWarning: {
			title: "Atención",
			description:
				"Este producto tiene ficha técnica y sus elementos serán reducidos del inventario solo cuando estén agotados.",
		},
	},
	notifications: {
		success: {
			input: "Cantidad agregada con éxito",
			remove: "Cantidad removida con éxito",
		},
		error: {
			input: "Error al agregar cantidad",
			remove: "Error al remover cantidad",
		},
	},
};

export const storageV2: StorageV2Translations = {
	backButtonLabel: "Volver a almacenes",
	tabs: {
		products: {
			title: "Productos en inventario",
			header: {
				filters: {
					search: {
						placeholder: "Buscar por producto",
					},
					category: {
						placeholder: "Filtrar por categoría",
						all: "Todas las categorías",
					},
					state: {
						placeholder: "Filtrar por estado de inventario",
						all: "Todos los productos",
						zero: "Inventario cero",
						negative: "Inventario negativo",
					},
				},
				actions: {
					inventory: "Inventariar inventario",
					inventoryTitle: "Inventariar inventario",
					addProducts: "Añadir productos",
					addProductsTitle: "Añadir productos al inventario",
					transferProducts: "Transferir productos",
					transferProductsTitle: "Transferir productos a otro inventario",
					importXml: "Importar XML",
					importXmlTitle: "Importar XML de nota fiscal de compra",
					importViaExcel: "Importar via Excel",
					importViaExcelTitle: "Importar via Excel",
				},
			},
			totalizers: {
				productsInStock: "Productos en inventario",
				totalCost: "Valor en inventario",
				productsWithoutCost: "Productos con costo cero",
				productsWithoutStock: "Productos con cantidad cero",
				seeProducts: "Ver productos",
			},
			table: productsTable,
			addStorageProductDrawer,
			importInvoiceDrawer,
			adjustStorageProductDrawer,
			adjustProductUnitCostValue: {
				label: "Actualizar costo unitario de {{productName}}",
				disabledLabel:
					"El costo unitario de {{productName}} no puede ser actualizado, porque el producto no tiene stock",
			},
			transferDrawer: {
				title: "Transferir producto del inventario {{productName}}",
				massTitle: "Transferir productos del inventario",
				form: {
					label: {
						product: "Producto",
						fromStorage: "Retirando productos del inventario",
						toStorage: "Transfiriendo productos al inventario",
						quantity: "Cantidad que desea transferir",
					},
					placeholder: {
						toStorage: "Seleccione el inventario",
					},
					hint: {
						maxQuantity: "Máximo disponible: {{maxQuantity}}",
					},
					sectionTitle: {
						chooseDestination: "Elija el inventario de destino",
					},
					validation: {
						maxStorageCountIs:
							"La cantidad máxima en inventario es {{productMaxCountString}}",
						missingField: "Campo obligatorio",
						invalidQuantity: "Cantidad inválida",
					},
				},
				mass: {
					sectionTitle: {
						productsList: "Lista de productos que se transferirán",
					},
					table: {
						columns: {
							product: "Producto",
							quantity: "Cantidad",
							unitCost: "Costo unitario",
							totalCost: "Costo total",
						},
						actions: {
							removeRow: "Eliminar producto",
						},
					},
				},
				actions: {
					cancel: "Cancelar",
					submit: "Concluir transferencia",
				},
				notifications: {
					success: "Transferencia completada con éxito.",
				},
			},
			removeProductFromStorageDialog: {
				title: "Eliminar producto",
				warningMessageSingle:
					"¿Está seguro de que desea eliminar el producto {{productName}} del inventario?",
				warningMessageMultiple:
					"¿Está seguro de que desea eliminar los {{count}} productos del inventario?",
				warningMessageStrong: " Esta acción no se puede deshacer",
				submit: "Eliminar producto",
				notifications: {
					success: "Producto eliminado del inventario con éxito.",
				},
			},
			removeMassProductsDialog: {
				title: "Eliminar productos",
				warningMessagePrefix: "¿Está seguro de que desea eliminar ",
				warningMessageAll: "todos los productos seleccionados",
				warningMessageSelected: "los {{count}} productos seleccionados",
				warningMessageSuffix: " del inventario? Esta acción no se puede deshacer.",
				submit: "Eliminar productos",
			},
			zeroMassProductsDialog: {
				title: "Poner en cero las cantidades de los productos",
				messagePrefix: "Estás a punto de poner en cero la cantidad de ",
				messageAll: "todos los productos seleccionados",
				messageSelected: "{{count}} productos seleccionados",
				messageSelectedSingle: "1 producto seleccionado",
				messageSuffix: ".",
				confirmQuestion: "¿Estás seguro de que deseas continuar?",
				submit: "Poner en cero productos",
				notifications: {
					success: "Cantidades de productos puestas en cero con éxito.",
				},
			},
			floatingActions: {
				selectedProduct: "{{count}} PRODUCTO SELECCIONADO",
				selectedProducts: "{{count}} PRODUCTOS SELECCIONADOS",
				resetProducts: "Poner productos en cero",
				transferProducts: "Transferir productos",
				deleteSelected: "Eliminar productos",
				tooltipResetProducts: "Poner en cero los productos seleccionados ({{count}})",
				tooltipTransferProducts: "Transferir productos seleccionados ({{count}})",
				tooltipDeleteSelected: "Eliminar productos seleccionados ({{count}})",
			},
		},
		inventory: {
			title: "Historial de inventarios",
		},
	},
};
